const VIGNETTE_ZONE = "10725662";
const VIGNETTE_SCRIPT_SRC = "https://gizokraijaw.net/vignette.min.js";
const SHOW_FN_NAME = `show_${VIGNETTE_ZONE}`;

/** Flip to true to re-enable ads. */
const ADS_ENABLED = false;

class AdService {
  private initialized = false;

  init(): void {
    if (!ADS_ENABLED) return;
    if (this.initialized) return;
    this.initialized = true;
    this.loadSdk();
  }

  private loadSdk(): void {
    const s = document.createElement("script");
    s.dataset.zone = VIGNETTE_ZONE;
    s.dataset.sdk = SHOW_FN_NAME;
    s.src = VIGNETTE_SCRIPT_SRC;
    document.head.appendChild(s);
  }

  /**
   * Triggers the Monetag vignette ad. Resolves when the ad is
   * closed/dismissed (promise from show_ZONE), or immediately
   * if the SDK isn't ready or no ad fills.
   */
  showAd(): Promise<boolean> {
    if (!ADS_ENABLED) return Promise.resolve(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showFn = (window as any)[SHOW_FN_NAME] as
      | ((...args: unknown[]) => Promise<void>)
      | undefined;

    if (!showFn || typeof showFn !== "function") {
      return Promise.resolve(true);
    }

    return showFn()
      .then(() => true)
      .catch(() => true);
  }

  isOverlayVisible(): boolean {
    return false;
  }
}

export const adService = new AdService();
